var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-list-container",attrs:{"id":"data-list-thumb-view"}},[_c('TableListOrders',{attrs:{"path":"locacao"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }